import {Card} from "@varymadellc/my-weed-club-component-library";
import Page from "@/layout/Page";
import EventsPageMenu from "@/layout/nav/EventsPageMenu";

export default function EventsPage() {
    return (
        <Page title='Upcoming Events'
              menu={<EventsPageMenu />}>
            <Card>
                <iframe
                    src="https://calendar.google.com/calendar/embed?height=600&wkst=1&bgcolor=%23ffffff&ctz=America%2FPhoenix&mode=AGENDA&showTitle=0&src=YWRtaW5AbXl3ZWVkLmNsdWI&color=%2333ae06"
                    style={{border: 0}} width="100%" height="600" frameBorder="0" scrolling="no"/>
            </Card>
        </Page>
    );
}
